export const BROADCAST_CHANNELS = {
  AUTHENTICATION: 'authentication',
  NBN_ORDER_CART: 'nbnOrderCart'
} as const;

export const NBN_ORDER_CART_ACTIONS = {
  ADDRESS_CHANGE: 'addressChange',
  CART_ERROR: 'cartError'
} as const;
